
import React from "react";
import { Route, Routes } from "react-router-dom";
import Users from "../Users/Users";
import Products from "../Products/Products";
import Archive from "../Archive/Archive";
import Payments from "../Payments/Payments";
import Category from "../Category/Category";
import Filters from "../Filters/Filters";
import Login from "../Login/Login";
import PrivateRoutes from "../PrivateRoutes/PrivateRoutes";
import ProductList from "../Listproducts/ProductList";
import PasswordResetPage from "../Profile/PasswordReset";
import PasswordResetChange from "../Profile/SetNewPassword";
import OrderManagement from "../OrderManagement/OrderManagement";
import UserOrdersInfo from "../userOrderInfo/UserOrdersInfo";
import Herosection from "../Herosection/Herosection";
import CreatePincode from "../Pincode/Pincode";
import TrailOrderManagement from "../trail orders/trailOrders";
import CouponManagement from "../CreateCoupon/CreateCoupon";  
import Marquee from "../Marquee/Marquee";
import Home from "../Home";
import CountdownManager from "../Countdown/Countdown";
import Analytics from "../Analytics/Analytics";
import HomepageManager from "../Homepage/Homepage";


export const AllRoutes = () => {
  return (
    <Routes>
      <Route
        path="#"
        element={
          <PrivateRoutes>
            <Analytics />
          </PrivateRoutes>
        }
      />
      <Route
        path="/home"
        element={
<Home />        }
      />
      <Route
        path="/"
        element={
          <PrivateRoutes>
            <Users />
          </PrivateRoutes>
        }
      />
      <Route
        path="/create-pincode"
        element={
          <PrivateRoutes>
            <CreatePincode />
          </PrivateRoutes>
        }
      />
      <Route
        path="/createproducts"
        element={
          <PrivateRoutes>
            <Products />
          </PrivateRoutes>
        }
      />
      {/* <Route
          path="/list/products"
          element={
            <PrivateRoutes>
              <ProductList/>
            </PrivateRoutes>
          }
        /> */}
        <Route
        path="/createarchive"
        element={
          // <PrivateRoutes>
          <Archive />
          // </PrivateRoutes>
        }
      />
      <Route
        path="/create-count-down"
        element={
          // <PrivateRoutes>
          <CountdownManager />
          // </PrivateRoutes>
        }
      />
      <Route
        path="/marquee-management"
        element={
          // <PrivateRoutes>
          <Marquee />
          // </PrivateRoutes>
        }
      />

      <Route
        path="/coupon-management"
        element={
          // <PrivateRoutes>
          <CouponManagement />
          // </PrivateRoutes>
        }
      />

      <Route
        path="/payment"
        element={
          // <PrivateRoutes>
          <Payments />
          // </PrivateRoutes>
        }
      />
      <Route
        path="/createcategory"
        element={
          // <PrivateRoutes>
          <Category />
          // </PrivateRoutes>
        }
      />
      <Route
        path="/filters"
        element={
          <PrivateRoutes>
            <Filters />
          </PrivateRoutes>
        }
      />
      <Route
        path="/login"
        element={
          // <PrivateRoutes>
          <Login />
          // </PrivateRoutes>
        }
      />
      <Route
        path="/password-reset"
        element={
          <PrivateRoutes>
            <PasswordResetPage />
          </PrivateRoutes>
        }
      />
      <Route
        path="/password-change"
        element={
          <PrivateRoutes>
            <PasswordResetChange />
          </PrivateRoutes>
        }
      />


      <Route
        path="/order-management"
        element={
          <PrivateRoutes>
            <OrderManagement />
          </PrivateRoutes>
        }
      />

      <Route
        path="/user/:id/orders"
        element={
          <PrivateRoutes>
            <UserOrdersInfo />
          </PrivateRoutes>
        }
      /> 
      <Route
        path="/hero-section"
        element={
          <PrivateRoutes>
            <Herosection />
          </PrivateRoutes>
        }
      />

      <Route
        path="/trail-order-management"
        element={
          <PrivateRoutes>
            <TrailOrderManagement />
          </PrivateRoutes>
        }
      />
      <Route
        path="/homepage-manager"
        element={
          <PrivateRoutes>
            <HomepageManager />
          </PrivateRoutes>
        }
      />

    </Routes>

   


  );
};

